import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { HotelRepository } from '@core/services/repositories/hotel.repository'
import { SharedModule } from '@shared/shared.module'
import { ActivatedRoute } from '@angular/router'
import { cdnUrl } from '../../app.module'

@Component({
  selector: 'iho-residency-group',
  templateUrl: './residency-group.component.html',
  styleUrls: ['./residency-group.component.scss'],
  standalone: true,
  providers: [HotelRepository],
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    SharedModule
]
})

export class residencyGroupComponent implements OnInit {
  listBreadcrumb: any;
  isLoading:boolean = true;
  skeletonItems = Array.from({ length: 4 });
    hotelRepo = inject(HotelRepository);
    route = inject(ActivatedRoute);
    data:any;
    cdnUrl = cdnUrl;
 constructor( ) {
  }
  ngOnInit(): void {
  
   this.getDataResidency();
  
}
getDataResidency(){
  this.isLoading = true;
  // get slug url  
  this.route.paramMap.subscribe((params:any) => {
    let groupCode = params.params.fullPath.split('-')[0];
    this.hotelRepo.getChainHotelsGroupCode(groupCode)
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.data = response;
          this.listBreadcrumb = response.Breadcrumbs;
        }
      )
  });
  
}
  roundDiscount(value: number | null | undefined): number {
    return Math.round(value ?? 0);
  }


}
